// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_9e1425b4d3--wrapper--buICq","_white":"_9e1425b4d3--_white--b7om4"};